import { useQuery } from '@tanstack/react-query';
import { getProgramFixedContentRows } from '../../services/programFixedContentService';
import { loadProgramFixedContentRowsCache } from '../../utils/programFixedContentRowsCache';
import { schoolKeys } from '../keys';
import { cacheOnlyQueryOptions } from './cacheOnlyQuery';
import { lsInitialDataOptions } from './lsInitialData';
import type { SchoolGradeTermScope } from './types';

export type UseProgramFixedRowsQueryParams = SchoolGradeTermScope & {
  enabled?: boolean;
  forceRefresh?: boolean;
  cacheOnly?: boolean;
};

export function programFixedRowsQueryOptions(params: UseProgramFixedRowsQueryParams) {
  const {
    workspaceId,
    academicYear,
    termNumber,
    gradeId,
    enabled = true,
    forceRefresh = false,
    cacheOnly = false,
  } = params;
  const ls = loadProgramFixedContentRowsCache(workspaceId, academicYear, termNumber, gradeId);

  return {
    queryKey: schoolKeys.programFixedRows(workspaceId, academicYear, termNumber, gradeId),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim(),
    ...lsInitialDataOptions(ls.found, ls.rows),
    ...cacheOnlyQueryOptions(cacheOnly),
    queryFn: () =>
      getProgramFixedContentRows(workspaceId, academicYear, termNumber, gradeId, {
        forceRefresh: cacheOnly ? false : forceRefresh,
      }),
  };
}

export function useProgramFixedRowsQuery(params: UseProgramFixedRowsQueryParams) {
  return useQuery(programFixedRowsQueryOptions(params));
}
